import React, { useState, useRef } from "react";
import { useRecoilState } from "recoil";
import { langState } from "./recoilAtom";
import { linksData, linksTopBar } from "./header";
import { ContentWrapper } from "./layout";
import { Link } from "gatsby";
import {
  EnvelopeFill,
  TelephoneFill,
  Linkedin,
  Youtube,
  Facebook,
} from "react-bootstrap-icons";
import { StaticImage } from "gatsby-plugin-image";

interface footerProps {
  children?: React.ReactNode;
  className?: string;
}

const currentYear = new Date().getFullYear();

const contactDetails: any = {
  "pl-PL": {
    Contact: `Kontakt`,
    phone: `+48 81 501 94 63`,
    phoneHref: `+48815019463`,
    emailAddress: `office@sdsoptic.pl`,
    address: `Adres`,
    streetDetails: `ul. Głęboka 39`,
    postalcodeDetails: `20-612 Lublin`,
    countryName: ``,
    linksTitle: `Linki`,
    copyrightText: `${currentYear} © SDS Optic S.A.`,
    privacyPolicy: `Regulamin i Polityka prywatności`,
  },
  "en-US": {
    Contact: `Contact`,
    phone: `+48 81 501 94 63`,
    phoneHref: `+48815019463`,
    emailAddress: `office@sdsoptic.pl`,
    address: `Address`,
    streetDetails: `Głęboka 39`,
    postalcodeDetails: `20-612 Lublin`,
    countryName: `Poland`,
    linksTitle: `Quick links`,
    copyrightText: `${currentYear} © SDS Optic S.A.`,
    privacyPolicy: `Terms & Conditions and Privacy Policy`,
  },
};

const Footer: React.FC<footerProps> = ({ children, className }) => {
  const [lang, setLang] = useRecoilState(langState);

  return (
    <footer className={className}>
      <ContentWrapper>
        <div className="upper-container">
          <div className="footer-width">
            <div className="links-wrapper">
              <h3>{contactDetails[lang].linksTitle}</h3>
              <ul className="footer-flag-wrapper">
                {linksData[lang].map((linkItem, idx) => (
                  <li key={idx + "footer-top"}>
                    <Link className="flex items-center" to={linkItem.url}>
                      {linkItem.text}
                    </Link>
                  </li>
                ))}
                {linksTopBar[lang].map((linkItem, idx) => (
                  <li key={idx + "footer-bottom"}>
                    <Link to={linkItem.url}>{linkItem.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="contact-wrapper">
              <span>{contactDetails[lang].Contact}</span>
              <a href={`tel:${contactDetails[lang].phoneHref}`}>
                <TelephoneFill />
                {contactDetails[lang].phone}
              </a>
              <a href={`mailto:${contactDetails[lang].emailAddress}`}>
                <EnvelopeFill />
                {contactDetails[lang].emailAddress}
              </a>

              <span>{contactDetails[lang].address}</span>
              <p>{contactDetails[lang].streetDetails}</p>
              <p>{contactDetails[lang].postalcodeDetails}</p>
              <p>{contactDetails[lang].countryName}</p>
            </div>
            <div className="third-column-wrapper">
              <span>
                {lang === "pl-PL" ? <>Zobacz nas na</> : <>Follow us</>}
              </span>
              <div className="social-media-wrapper">
                <h3 className="social-media-followus"></h3>
                <div className="social-media-icons">
                  <a
                    href="https://www.linkedin.com/company/sds-optic/posts/?feedView=all"
                    // target="_blank"
                  >
                    <Linkedin />
                  </a>
                  <a
                    href="https://www.youtube.com/results?search_query=SDS+Optic"
                    // target="_blank"
                  >
                    <Youtube />
                  </a>
                  <a
                    href="https://www.facebook.com/sdsoptic/?locale=pl_PL"
                    // target="_blank"
                  >
                    <Facebook />
                  </a>
                </div>
              </div>
              <div className="nip-regon-krs-holder">
                <p>NIP: 7123279546</p>
                <p>REGON: 067574802</p>
                <p>KRS: 0000786821</p>
              </div>
            </div>
          </div>
        </div>
      </ContentWrapper>
      <div className="lower-container">
        <span>{contactDetails[lang].copyrightText}</span>
        <a className="privacy-policy" href="/termsandprivacy">
          {contactDetails[lang].privacyPolicy}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
